import { ARBITRUM, ARBITRUM_TESTNET, AVALANCHE, MAINNET, TESTNET, ETHEREUM } from "./chains";

export const XGMT_EXCLUDED_ACCOUNTS = [
  "0x330eef6b9b1ea6edd620c825c9919dc8b611d5d5",
  "0xd9b1c23411adbb984b1c4be515fafc47a12898b2",
  "0xa633158288520807f91ccc98aa58e0ea43acb400",
  "0xffd0a93b4362052a336a7b22494f1b77018dd34b",
];

const CONTRACTS = {
  [MAINNET]: {
    // bsc mainnet
    Treasury: "0xa44E7252a0C137748F523F112644042E5987FfC7",
    BUSD: "0xe9e7cea3dedca5984780bafc599bd69add087d56",
    GMT: "0x99e92123eB77Bc8f999316f622e5222498438784",
    Vault: "0xc73A8DcAc88498FD4b4B1b2AaA37b0a2614Ff67B",
    Router: "0xD46B23D042E976F8666F554E928e0Dc7478a8E1f",
    Reader: "0x087A618fD25c92B61254DBe37b09E5E8065FeaE7",
    AmmFactory: "0xBCfCcbde45cE874adCB698cC183deBcF17952812",
    AmmFactoryV2: "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73",
    OrderBook: "0x1111111111111111111111111111111111111111",
    OrderBookReader: "0x1111111111111111111111111111111111111111",
    GmxMigrator: "0xDEF2af818514c1Ca1A9bBe2a4D45E28f260063f9",
    USDG: "0x85E76cbf4893c1fbcB34dCF1239A91CE2A4CF5a7",
    NATIVE_TOKEN: "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
    XGMT: "0xe304ff0983922787Fd84BC9170CD21bF78B16B10",
    GMT_USDG_PAIR: "0xa41e57459f09a126F358E118b693789d088eA8A0",
    XGMT_USDG_PAIR: "0x0b622208fc0691C2486A3AE6B7C875b4A174b317",
    GMT_USDG_FARM: "0x3E8B08876c791dC880ADC8f965A02e53Bb9C0422",
    XGMT_USDG_FARM: "0x68D7ee2A16AB7c0Ee1D670BECd144166d2Ae0759",
    USDG_YIELD_TRACKER: "0x0EF0Cf825B8e9F89A43FfD392664131cFB4cfA89",
    XGMT_YIELD_TRACKER: "0x82A012A9b3003b18B6bCd6052cbbef7Fa4892e80",
    GMT_USDG_FARM_TRACKER_XGMT: "0x08FAb024BEfcb6068847726b2eccEAd18b6c23Cd",
    GMT_USDG_FARM_TRACKER_NATIVE: "0xd8E26637B34B2487Cad1f91808878a391134C5c2",
    XGMT_USDG_FARM_TRACKER_XGMT: "0x026A02F7F26C1AFccb9Cba7C4df3Dc810F4e92e8",
    XGMT_USDG_FARM_TRACKER_NATIVE: "0x22458CEbD14a9679b2880147d08CA1ce5aa40E84",
    AUTO: "0xa184088a740c695E156F91f5cC086a06bb78b827",
    AUTO_USDG_PAIR: "0x0523FD5C53ea5419B4DAF656BC1b157dDFE3ce50",
    AUTO_USDG_FARM: "0xE6958298328D02051769282628a3b4178D0F3A47",
    AUTO_USDG_FARM_TRACKER_XGMT: "0x093b8be41c1A30704De84a9521632f9a139c08bd",
    AUTO_USDG_FARM_TRACKER_NATIVE: "0x23ed48E5dce3acC7704d0ce275B7b9a0e346b63A",
    GMT_GMX_IOU: "0x47052469970C2484729875CC9E2dd2683fcE71fb",
    XGMT_GMX_IOU: "0xeB3733DFe3b68C9d26898De2493A3Bb59FDb4A7B",
    GMT_USDG_GMX_IOU: "0x481312655F81b5e249780A6a49735335BF6Ca7f4",
    XGMT_USDG_GMX_IOU: "0x8095F1A92526C304623483018aA28cC6E62EB1e1",
  },
  [TESTNET]: {
    // bsc testnet
    Vault: "0x1B183979a5cd95FAF392c8002dbF0D5A1C687D9a",
    Router: "0x10800f683aa564534497a5b67F45bE3556a955AB",
    Reader: "0x98D4742F1B6a821bae672Cd8721283b91996E454",
    AmmFactory: "0x6725f303b657a9451d8ba641348b6761a6cc7a17",
    AmmFactoryV2: "0x1111111111111111111111111111111111111111",
    OrderBook: "0x9afD7B4f0b58d65F6b2978D3581383a06b2ac4e9",
    OrderBookReader: "0x0713562970D1A802Fa3FeB1D15F9809943982Ea9",
    GmxMigrator: "0xDEF2af818514c1Ca1A9bBe2a4D45E28f260063f9",
    USDG: "0x2D549bdBf810523fe9cd660cC35fE05f0FcAa028",
    GMT: "0xedba0360a44f885ed390fad01aa34d00d2532817",
    NATIVE_TOKEN: "0x612777Eea37a44F7a95E3B101C39e1E2695fa6C2",
    XGMT: "0x28cba798eca1a3128ffd1b734afb93870f22e613",
    GMT_USDG_PAIR: "0xe0b0a315746f51932de033ab27223d85114c6b85",
    XGMT_USDG_PAIR: "0x0108de1eea192ce8448080c3d90a1560cf643fa0",
    GMT_USDG_FARM: "0xbe3cB06CE03cA692b77902040479572Ba8D01b0B",
    XGMT_USDG_FARM: "0x138E92195D4B99CE3618092D3F9FA830d9A69B4b",
    USDG_YIELD_TRACKER: "0x62B49Bc3bF252a5DB26D88ccc7E61119e3179B4f",
    XGMT_YIELD_TRACKER: "0x5F235A582e0993eE9466FeEb8F7B4682993a57d0",
    GMT_USDG_FARM_TRACKER_XGMT: "0x4f8EE3aE1152422cbCaFACd4e3041ba2D859913C",
    GMT_USDG_FARM_TRACKER_NATIVE: "0xd691B26E544Fe370f39A776964c991363aF72e56",
    XGMT_USDG_FARM_TRACKER_XGMT: "0xfd5617CFB082Ba9bcD62d654603972AE312bC695",
    XGMT_USDG_FARM_TRACKER_NATIVE: "0x0354387DD85b7D8aaD1611B3D167A384d6AE0c28",
    GMT_GMX_IOU: "0x47052469970C2484729875CC9E2dd2683fcE71fb",
    XGMT_GMX_IOU: "0xeB3733DFe3b68C9d26898De2493A3Bb59FDb4A7B",
    GMT_USDG_GMX_IOU: "0x481312655F81b5e249780A6a49735335BF6Ca7f4",
    XGMT_USDG_GMX_IOU: "0x8095F1A92526C304623483018aA28cC6E62EB1e1",
  },
  [ARBITRUM_TESTNET]: {
    // arbitrum testnet
    Vault: "0xBc9BC47A7aB63db1E0030dC7B60DDcDe29CF4Ffb",
    Router: "0xe0d4662cdfa2d71477A7DF367d5541421FAC2547",
    VaultReader: "0xFc371E380262536c819D12B9569106bf032cC41c",
    Reader: "0x2E093c70E3A7E4919611d2555dFd8D697d2fC0a1",
    GlpManager: "0xD875d99E09118d2Be80579b9d23E83469077b498",
    RewardRouter: "0x0000000000000000000000000000000000000000",
    RewardReader: "0x0000000000000000000000000000000000000000",
    NATIVE_TOKEN: "0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681",
    GLP: "0xb4f81Fa74e06b5f762A104e47276BA9b2929cb27",
    GMX: "0x0000000000000000000000000000000000000000",
    ES_GMX: "0x0000000000000000000000000000000000000000",
    BN_GMX: "0x0000000000000000000000000000000000000000",
    USDG: "0xBCDCaF67193Bf5C57be08623278fCB69f4cA9e68",
    ES_GMX_IOU: "0x0000000000000000000000000000000000000000",
    StakedGmxTracker: "0x0000000000000000000000000000000000000000",
    BonusGmxTracker: "0x0000000000000000000000000000000000000000",
    FeeGmxTracker: "0x0000000000000000000000000000000000000000",
    StakedGlpTracker: "0x0000000000000000000000000000000000000000",
    FeeGlpTracker: "0x0000000000000000000000000000000000000000",

    StakedGmxDistributor: "0x0000000000000000000000000000000000000000",
    StakedGlpDistributor: "0x0000000000000000000000000000000000000000",

    GmxVester: "0x0000000000000000000000000000000000000000",
    GlpVester: "0x0000000000000000000000000000000000000000",

    OrderBook: "0xebD147E5136879520dDaDf1cA8FBa48050EFf016",
    OrderBookReader: "0xC492c8d82DC576Ad870707bb40EDb63E2026111E",

    PositionRouter: "0xB4bB78cd12B097603e2b55D2556c09C17a5815F8",
    PositionManager: "0x168aDa266c2f10C1F37973B213d6178551030e44",

    // UniswapGmxEthPool: "0x80A9ae39310abf666A87C743d6ebBD0E8C42158E",
    ReferralStorage: "0x0000000000000000000000000000000000000000",
    ReferralReader: "0x0000000000000000000000000000000000000000",
  },
  [ARBITRUM]: {
    // arbitrum mainnet
    Vault: "0x489ee077994B6658eAfA855C308275EAd8097C4A",
    Router: "0xaBBc5F99639c9B6bCb58544ddf04EFA6802F4064",
    VaultReader: "0xfebB9f4CAC4cD523598fE1C5771181440143F24A",
    Reader: "0x2b43c90D1B727cEe1Df34925bcd5Ace52Ec37694",
    GlpManager: "0x321F653eED006AD1C29D174e17d96351BDe22649",
    RewardRouter: "0xA906F338CB21815cBc4Bc87ace9e68c87eF8d8F1",
    RewardReader: "0x8BFb8e82Ee4569aee78D03235ff465Bd436D40E0",
    NATIVE_TOKEN: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    GLP: "0x4277f8F2c384827B5273592FF7CeBd9f2C1ac258",
    GMX: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
    ES_GMX: "0xf42Ae1D54fd613C9bb14810b0588FaAa09a426cA",
    BN_GMX: "0x35247165119B69A40edD5304969560D0ef486921",
    USDG: "0x45096e7aA921f27590f8F19e457794EB09678141",
    ES_GMX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954",
    StakedGmxTracker: "0x908C4D94D34924765f1eDc22A1DD098397c59dD4",
    BonusGmxTracker: "0x4d268a7d4C16ceB5a606c173Bd974984343fea13",
    FeeGmxTracker: "0xd2D1162512F927a7e282Ef43a362659E4F2a728F",
    StakedGlpTracker: "0x1aDDD80E6039594eE970E5872D247bf0414C8903",
    FeeGlpTracker: "0x4e971a87900b931fF39d1Aad67697F49835400b6",

    StakedGmxDistributor: "0x23208B91A98c7C1CD9FE63085BFf68311494F193",
    StakedGlpDistributor: "0x60519b48ec4183a61ca2B8e37869E675FD203b34",

    GmxVester: "0x199070DDfd1CFb69173aa2F7e20906F26B363004",
    GlpVester: "0xA75287d2f8b217273E7FCD7E86eF07D33972042E",

    OrderBook: "0x09f77E8A13De9a35a7231028187e9fD5DB8a2ACB",
    OrderExecutor: "0x7257ac5D0a0aaC04AA7bA2AC0A6Eb742E332c3fB",
    OrderBookReader: "0xa27C20A7CF0e1C68C0460706bB674f98F362Bc21",

    PositionRouter: "0xb87a436B93fFE9D75c5cFA7bAcFff96430b09868",
    PositionManager: "0x75E42e6f01baf1D6022bEa862A28774a9f8a4A0C",

    UniswapGmxEthPool: "0x80A9ae39310abf666A87C743d6ebBD0E8C42158E",
    ReferralStorage: "0xe6fab3f0c7199b0d34d7fbe83394fc0e0d06e99d",
    ReferralReader: "0x8Aa382760BCdCe8644C33e6C2D52f6304A76F5c8",
  },
  // [AVALANCHE]: {
  //   // avalanche
  //   Vault: "0x9ab2De34A33fB459b538c43f251eB825645e8595",
  //   Router: "0x5F719c2F1095F7B9fc68a68e35B51194f4b6abe8",
  //   VaultReader: "0x66eC8fc33A26feAEAe156afA3Cb46923651F6f0D",
  //   Reader: "0x2eFEE1950ededC65De687b40Fd30a7B5f4544aBd",
  //   GlpManager: "0xe1ae4d4b06A5Fe1fc288f6B4CD72f9F8323B107F",
  //   RewardRouter: "0x82147C5A7E850eA4E28155DF107F2590fD4ba327",
  //   RewardReader: "0x04Fc11Bd28763872d143637a7c768bD96E44c1b6",
  //   NATIVE_TOKEN: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
  //   GLP: "0x01234181085565ed162a948b6a5e88758CD7c7b8",
  //   GMX: "0x62edc0692BD897D2295872a9FFCac5425011c661",
  //   ES_GMX: "0xFf1489227BbAAC61a9209A08929E4c2a526DdD17",
  //   BN_GMX: "0x8087a341D32D445d9aC8aCc9c14F5781E04A26d2",
  //   USDG: "0xc0253c3cC6aa5Ab407b5795a04c28fB063273894",
  //   ES_GMX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder address

  //   StakedGmxTracker: "0x2bD10f8E93B3669b6d42E74eEedC65dd1B0a1342",
  //   BonusGmxTracker: "0x908C4D94D34924765f1eDc22A1DD098397c59dD4",
  //   FeeGmxTracker: "0x4d268a7d4C16ceB5a606c173Bd974984343fea13",
  //   StakedGlpTracker: "0x9e295B5B976a184B14aD8cd72413aD846C299660",
  //   FeeGlpTracker: "0xd2D1162512F927a7e282Ef43a362659E4F2a728F",

  //   StakedGmxDistributor: "0xfc5A1A6EB076a2C7aD06eD22C90d7E710E35ad0a",
  //   StakedGlpDistributor: "0xDd593Cf40734199afc9207eBe9ffF23dA4Bf7720",

  //   GmxVester: "0x472361d3cA5F49c8E633FB50385BfaD1e018b445",
  //   GlpVester: "0x62331A7Bd1dfB3A7642B7db50B5509E57CA3154A",

  //   OrderBook: "0x4296e307f108B2f583FF2F7B7270ee7831574Ae5",
  //   OrderExecutor: "0x4296e307f108B2f583FF2F7B7270ee7831574Ae5",
  //   OrderBookReader: "0xccFE3E576f8145403d3ce8f3c2f6519Dae40683B",

  //   PositionRouter: "0xffF6D276Bc37c61A23f06410Dce4A400f66420f8",
  //   PositionManager: "0xA21B83E579f4315951bA658654c371520BDcB866",

  //   TraderJoeGmxAvaxPool: "0x0c91a070f862666bbcce281346be45766d874d98",
  //   ReferralStorage: "0x827ed045002ecdabeb6e2b0d1604cf5fc3d322f8",
  //   ReferralReader: "0x505Ce16D3017be7D76a7C2631C0590E71A975083",
  // },
  [AVALANCHE]: {
    // avalanche
    Vault: "0x788aA38e6d6CE186E63c709a81E566ec6CedC33c",//replaced 0x2a5bae3eaec36d147dFE859b1a68F1A5eCCB0dd5
    Router: "0xc99A9464fb07c0fd6eed8F6690ed04833E068509",//replaced 0x8F16166be2B3a778AbBA0EbaaeC8f6bd8d4aD705
    VaultReader: "0xa98d70D352b18d030Bfa9b277EE6d911261690b5",//replaced 0xD9193457a09fA7a16e3B628129F43C1D0Ff6c6eD
    Reader: "0x49ACBfdc6F71B2a704fed4576c8c5498f8F9E34F",//replaced 0x5921A3E1545A374C20Ab1f7413d78B3815b667dA
    GlpManager: "0x93441c62Ea1f6389Ed12960510d8e4B633b366Bc",//replaced 0x9d530DdC986bd20beC3E70dC5382dF2e0a1bE7a6
    RewardRouter: "0x3Fb4Ab1278403063691D07ECf812996A277c9a2B",//replaced 0x6E53C1cDA69858B02779FA2656F8C19a933CB9e0
    RewardReader: "0x6D4e31eae9F306a672e71ECB8009D1E16fbDa505",//replaced 0xC1aEad06886edaBE97e068800EF2877568C2fFAf
    NATIVE_TOKEN: "0xB31f66AA3C1e785363F0875A1B74E27b85FD66c7",
    GLP: "0xC249A12b8cFf48bceb8f7Cb5027a2aaa5f87A437",//replaced 0x0E2b5428CE48c87a33Ad55A14d3b79BC7300C241
    GMX: "0x75fcC61CD1e22FfA8f3Ad1D1903301C54C622189", //replaced 0xDc2C540Fd99eb5dC424095C8C6A63f7c805D46e9
    ES_GMX: "0x8DA3E2C2C055A4d62eaca530274d343C6789c486",//replaced 0xafb5b77201aF3afbeE2b25c76b2DcE618a65d3bf
    BN_GMX: "0xD4bE9134201CFae62860637AB0a385553EF49f0B",//replaced 0xE7807Af3c341CeA2f02a414e444aAD85B4D3d6df
    USDG: "0xF2C43885925c162Bba723b0c58BdAae8cD08d3Bc", //replaced 0xCFc3be74C254Ca3F6B029780F804CE1289793756
    ES_GMX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder address

    StakedGmxTracker: "0x05Af0Ab2314A002fb099E4ac27a94E8b3eFDB911",//replaced 0x81d201D05162B2E5f6B990E5950841651066438B
    BonusGmxTracker: "0x5ED90BE42dd35B0FBC2Ab0002495CB45A3dA0b5B",//replaced 0xBb694c9D5454CbFbA8f2befde84204c7FD4D3bc5
    FeeGmxTracker: "0xdBe3736032cDeF5eC5c8F0D1604d4295C7fc5C61",//replaced 0x71fbf7C63a196CE008aAbd2f9BB68619bFb3A837
    StakedGlpTracker: "0x04200879b0B8CFa81c6E14235058e40398bB398B",//replaced 0x508a28d2d6B866cA6DE03044D32FE05E8672d55E
    FeeGlpTracker: "0xa2802279EDE08d2860b5cC0494c04DC860451C31",//replaced 0xacE33f27a278f110CCcAedaD77481DE1598793b1

    StakedGmxDistributor: "0xc9320e5b808a907f3ea1e060d2E9500dF820aC57",//replaced 0xa7256d891F294866Bc060c764C1B3c15b66C798B
    StakedGlpDistributor: "0xC981411b6f92429c98F3Ac4eC8Cb7482b10AB5d3",//replaced 0x9a8fe3cCe5ca1470D213aFcb0C04ba46525c631F

    GmxVester: "0x3D26D9A0975478145761389903A8E624f1821587",//replaced 0x57Ff6E61E703293742F1a4aF22262582E03429cb
    GlpVester: "0x7b15F4394d2DC8A55650B09788871be65e7E7806",//replaced 0x9024C2ac08c250fCACD1c6D60D7321c759af2cd5

    OrderBook: "0x9C254aA7A1cCa2C33FB75598959EaC0c37d0b2db",//replaced 0x2cd0640F9bA7C0a0306C92a674be4f89eF89cE80
    OrderExecutor: "0x9C254aA7A1cCa2C33FB75598959EaC0c37d0b2db",//replaced 0x2cd0640F9bA7C0a0306C92a674be4f89eF89cE80
    OrderBookReader: "0x847b575f0E5275d4A2ab6437CE7A8E6793842c78",//replaced 0xD44d5D7605c388bE8A9eeEBc37Ba24188CD1e634

    PositionRouter: "0xa9913615A1DFdd239a815eb80f3794c03Bf85343",//replaced 0xA8A8ef28cE7cDC25319f0E13fD8245F26caf8849
    PositionManager: "0x45704Ae383c26CCb19e16112bA0CDaF2C08786d8",//replaced 0xda18A5372fF256314fd3654FA074B4d949aBE823

    TraderJoeGmxAvaxPool: "0xf9Db46fE7c8322088882124d8fdCB4E9fBF38d64",//replaced
    ReferralStorage: "0x65778E6c12cB4A71de887BF21Af47acA50f81560",//replaced 0xF51Def0A8A991E2Aa227643271d290c2DAa8cFCe
    ReferralReader: "0xc14cEE936C58Db3Ce9239bf29bE27c5473945778",//replaced 0x69A0542B67622056B401159360692b1011B23B87
  },
  [ETHEREUM]: {
    // avalanche
    Vault: "0x7Db7224d951a071C616BE5198A242da03600054B",//replaced 
    Router: "0xA0aFb858e11C247ea96aE12C7ca067a649A83Fd0",//replaced 
    VaultReader: "0xD4e065B1eec42fCD62c1151922A3575dce6B2dDf",//replaced 
    Reader: "0x2a5bae3eaec36d147dFE859b1a68F1A5eCCB0dd5",//replaced 
    GlpManager: "0xdA10E441262aE9dD464ae3c620ea33dBdA44135D",//replaced 
    RewardRouter: "0x11bbdDBf154B014D50323abC39F347ca0a0955A3",//replaced 
    RewardReader: "0x8F16166be2B3a778AbBA0EbaaeC8f6bd8d4aD705",//replaced 
    NATIVE_TOKEN: "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
    GLP: "0x86cf5A90aDFF0E5d8B817989A47c36F3F56134ED",//replaced 
    GMX: "0xDc2C540Fd99eb5dC424095C8C6A63f7c805D46e9", //replaced 
    ES_GMX: "0x02a8255E8fa854A2E09be21aC7A77272d9BB8547",//replaced 
    BN_GMX: "0x6744f50CAe2B2D0656dcd691BC0161ff3E590635",//replaced 
    USDG: "0x447919Fa42cBabdC8418b85aB8F86f7225d08A65", //replaced 
    ES_GMX_IOU: "0x6260101218eC4cCfFF1b778936C6f2400f95A954", // placeholder address

    StakedGmxTracker: "0x0E2b5428CE48c87a33Ad55A14d3b79BC7300C241",//replaced        0x81d201D05162B2E5f6B990E5950841651066438B
    BonusGmxTracker: "0x30b70dC4784ea40cc42FeCFC8eA2d054112A47B2",//replaced          0xBb694c9D5454CbFbA8f2befde84204c7FD4D3bc5
    FeeGmxTracker: "0x3Ec4dd6FB1a4767c736Bc7349dCc36b970120c5b",//replaced            0x71fbf7C63a196CE008aAbd2f9BB68619bFb3A837
    StakedGlpTracker: "0xD9193457a09fA7a16e3B628129F43C1D0Ff6c6eD",//replaced         0x508a28d2d6B866cA6DE03044D32FE05E8672d55E
    FeeGlpTracker: "0xdf5D950441D45bB12Ab2EB4C8f21dD43BF979f13",//replaced            0xacE33f27a278f110CCcAedaD77481DE1598793b1

    StakedGmxDistributor: "0x26be63dB2D08FD3782D5c7a2767A9456142f5Af6",//replaced          0xa7256d891F294866Bc060c764C1B3c15b66C798B
    StakedGlpDistributor: "0x5921A3E1545A374C20Ab1f7413d78B3815b667dA",//replaced          0x9a8fe3cCe5ca1470D213aFcb0C04ba46525c631F

    GmxVester: "0xB858972eFBfF03aB3a2c019e7192bF6d79672ccD",//replaced 
    GlpVester: "0x71fbf7C63a196CE008aAbd2f9BB68619bFb3A837",//replaced 

    OrderBook: "0x1B86b30Dc32fF2AB59BB563645208CE15b6b7d33",//replaced 
    OrderExecutor: "0x1B86b30Dc32fF2AB59BB563645208CE15b6b7d33",//replaced 
    OrderBookReader: "0xDA6185fcC9DcEbb4D541F104BA2c642C5fC8b7D0",//replaced 

    PositionRouter: "0xF5D6433ec059D99D1cf452e6CF58953f462C6CA7",//replaced 
    PositionManager: "0x8D95CAD82637b5F5D5C79809ccBbC6027DA425D4",//replaced 

    TraderJoeGmxAvaxPool: "0xA1A954389fB4A24d7b338032B20B4D924A470F9b",//replaced
    ReferralStorage: "0x78B718D23A171310de810Cc43e124577a477ec07",//replaced 
    ReferralReader: "0x5D0F876DdBeCf6B781a7B22C27cD1aF7C209C992",//replaced 
  },
};

export function getContract(chainId: number, name: string): string {
  if (!CONTRACTS[chainId]) {
    throw new Error(`Unknown chainId ${chainId}`);
  }

  if (!CONTRACTS[chainId][name]) {
    throw new Error(`Unknown contract "${name}" for chainId ${chainId}`);
  }

  return CONTRACTS[chainId][name];
}
